import clsx from 'clsx'
import React, {useState} from 'react'
import {KTIcon} from '@/_metronic/helpers'
import {Field, useFormikContext} from 'formik'
import {RawFileUpload} from '@/components/form'
import {Product} from '../../../../core/_models'
import {Card} from '@/components/Card'

const ThumbnailCard = () => {
  const {values, setFieldValue} = useFormikContext()
  const product = values as Product
  const cover = product.cover ? product.cover : null
  const [previewImage, setPreviewImage] = useState<string | null>(cover)


  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreviewImage(reader.result as string)
      }
      reader.readAsDataURL(file)
    } else {
      setPreviewImage(null)
    }
  }

  return (
    <Card
      title='Thumbnail'
      collapsable={false}
      className="card card-custom overlay overflow-hidden"
    >
      <div className="text-center">
        <div
          className={clsx('image-input image-input-outline image-input-placeholder mb-3  ', {
            'image-input-empty': !product?.cover && !previewImage,
            'image-input-changed': true
          })}
        >
          <div className="overlay-wrapper">
            <div className="image-input-wrapper w-150px h-150px">
              {previewImage && (
                <img src={previewImage} alt="Product cover" className="w-150px h-150px" />
              )}
            </div>
          </div>
          {cover && (
            <div className="overlay-layer bg-dark bg-opacity-10">
              <a href={cover} className="btn btn-primary btn-shadow" target="_blank" rel="noreferrer">
                View
              </a>
            </div>
          )}
          <label
            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow  image-input-changed"
            data-kt-image-input-action="change"
            title="Change cover"
          >
            <KTIcon iconName="pencil" className="fs-7" />
            <Field
              type="file"
              name="coverFile"
              accept=".webp"
              component={RawFileUpload}
              onChange={handleImageChange}
              style={{padding: '0px'}}
            />
          </label>
          <span
            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow  image-input-changed"
            data-kt-image-input-action="cancel"
            title="Cancel cover"
            onClick={() => {
              setPreviewImage(null)
              setFieldValue('coverFile', null)
            }}
          >
            <KTIcon iconName="cross" className="fs-2" />
          </span>
        </div>
        <div className="text-muted fs-7">Set the product thumbnail image. Only *.png, *.jpg and *.jpeg image files are accepted</div>
      </div>
    </Card>
  )
}

export {ThumbnailCard}
